import type { WorkItem } from '@/modules/project/api/work-item'

export interface LanguagePairSummaryInput {
  source_language?: string | null
  target_languages?: string[] | null
  target_count?: number | null
}

/** 目录语言对文案：源 → 目的语；≥2 目的语时追加（n） */
export function formatLanguagePairLabel(
  summary: LanguagePairSummaryInput | null | undefined,
  labelOf: (code?: string | null) => string,
  emptyTarget = '—',
): string {
  const source = labelOf(summary?.source_language)
  const targets = (summary?.target_languages || []).filter(Boolean)
  if (targets.length === 0) {
    return `${source} → ${emptyTarget}`
  }
  const targetText = targets.map((code) => labelOf(code)).join('、')
  if (targets.length >= 2) {
    const n = summary?.target_count ?? targets.length
    return `${source} → ${targetText}（${n}）`
  }
  return `${source} → ${targetText}`
}

/** 无 summary 时回退 WI 单字段 */
export function languagePairSummaryFromWorkItem(
  item: Pick<WorkItem, 'source_language' | 'target_language' | 'language_pair_summary'>,
): LanguagePairSummaryInput {
  if (item.language_pair_summary) {
    return item.language_pair_summary
  }
  const target = (item.target_language || '').trim()
  return {
    source_language: item.source_language,
    target_languages: target ? [target] : [],
    target_count: target ? 1 : 0,
  }
}
